import { useEffect } from "react"
import { useSearchParams } from "react-router"

import { SearchParamKey } from "@app/store/appStore.types"
import { useAccessTokenStore } from "@shared/store/useAccessTokenStore"

const useAccessToken = () => {
    const [params, setParams] = useSearchParams()

    const accessTokenFromUrl = params.get(SearchParamKey.ACCESS_TOKEN)

    const accessToken = useAccessTokenStore(s => s.accessToken)
    const setAccessToken = useAccessTokenStore(s => s.setAccessToken)
    const reset = useAccessTokenStore(s => s.reset)

    useEffect(() => {
        if (accessTokenFromUrl) {
            if (accessToken !== accessTokenFromUrl) {
                setAccessToken(accessTokenFromUrl)
            }
            params.delete(SearchParamKey.ACCESS_TOKEN)
            setParams(prev => {
                const next = new URLSearchParams(prev)
                next.delete(SearchParamKey.ACCESS_TOKEN)
                return next
            }, { replace: true })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessTokenFromUrl])

    return { accessToken, setAccessToken, reset }
}

export default useAccessToken
